module.exports = __webpack_public_path__ + "assets/img/Walmart_logo@2x.ed01418b.png";